export type ArticleCategory = "gossip" | "black" | "news";

export type ContentBlock =
  | { type: "p"; text: string }
  | { type: "h2"; text: string }
  | { type: "quote"; text: string }
  | { type: "image"; src: string; caption: string };

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: ArticleCategory;
  cover: string;
  date: string;
  author: string;
  tags: string[];
  region?: string;
  eventType?: string;
  newsType?: string;
  views: number;
  likes: number;
  featured?: boolean;
  content: ContentBlock[];
}

export const categoryLabels: Record<ArticleCategory, string> = {
  gossip: "明星八卦",
  black: "明星黑料",
  news: "娱乐新闻",
};

export const categoryPaths: Record<ArticleCategory, string> = {
  gossip: "/gossip",
  black: "/black",
  news: "/news",
};

export const articles: Article[] = [
  {
    id: "g1",
    title: "林澈苏念深夜同回公寓 恋情疑云再起，双方团队暂未回应",
    excerpt:
      "连续两周被拍到同进同出同一栋公寓，两人从合作剧集到私下聚会的行程高度重叠，恋情传闻迅速登上热搜。",
    category: "gossip",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20street%20scene%20in%20a%20modern%20asian%20city%2C%20two%20stylish%20silhouettes%20walking%20side%20by%20side%20under%20warm%20street%20lamps%2C%20soft%20bokeh%20lights%2C%20moody%20navy%20tones%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=1600&height=900&seq=gossip-night-walk-2610&orientation=landscape",
    date: "2026-10-16",
    author: "编辑 · 沈一白",
    tags: ["林澈", "苏念", "恋情", "同框"],
    eventType: "恋情",
    views: 1284000,
    likes: 42600,
    featured: true,
    content: [
      {
        type: "p",
        text: "本周三深夜，有网友在社交平台发布一组照片，称在某影视基地附近的公寓楼下目击林澈与苏念先后下车。照片显示，两人着装低调，前后脚进入同一单元门，全程未见助理随行。",
      },
      {
        type: "p",
        text: "这已经是近两周内第三次被拍到两人出现在同一地点。此前两人因合作剧集《长夜微光》结缘，剧集杀青后仍保持频繁互动，社交账号上的猫、咖啡杯与同款抱枕被网友逐一比对。",
      },
      { type: "h2", text: "行程重叠：从剧组到生活圈" },
      {
        type: "p",
        text: "根据公开行程整理，苏念九月下旬的两场品牌活动与林澈的录音安排均在同一城区，且中间空出了整整两天的休息时间。工作人员在被问及此事时，仅回应「艺人的私人时间不便透露」。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Quiet%20modern%20city%20street%20at%20night%20with%20rain%20reflections%2C%20warm%20windows%20and%20neon%20blur%2C%20no%20people%2C%20atmospheric%20cinematic%20mood%2C%20deep%20navy%20and%20amber%20tones&width=1000&height=620&seq=gossip-night-city-detail&orientation=landscape",
        caption: "两人被拍到的地点位于影视基地附近的一处公寓区。",
      },
      {
        type: "quote",
        text: "「我们目前专注作品，其他事情不占用公共讨论空间。」——苏念工作室在九月的一次采访中的回应。",
      },
      {
        type: "p",
        text: "值得关注的是，两人下一部作品的档期几乎完全错开，这在此前的宣传节奏中并不常见。有业内人士认为，若恋情属实，双方团队可能选择在作品宣传期结束后再统一回应。",
      },
      { type: "h2", text: "粉丝反应两极" },
      {
        type: "p",
        text: "消息发酵后，相关话题阅读量在两小时内突破三亿。部分粉丝表示「只要作品不掉线就祝福」，也有粉丝整理出时间线，认为照片存在剪辑与拼接的可能，呼吁等待官方说明。",
      },
      {
        type: "p",
        text: "截至发稿，双方经纪公司均未就此事作出正式回应。我们将持续关注后续进展。",
      },
    ],
  },
  {
    id: "g2",
    title: "沈知夏片场探班神秘男子 工作人员称只是多年好友",
    excerpt:
      "新剧拍摄现场出现一位全程陪同的神秘男子，两人休息时并肩聊天近半小时，剧组回应称对方是多年的朋友。",
    category: "gossip",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20backstage%20dressing%20room%20with%20makeup%20mirror%20bulbs%2C%20costume%20racks%20and%20script%20papers%2C%20cinematic%20soft%20lighting%2C%20no%20people%2C%20amber%20and%20cream%20tones&width=800&height=600&seq=gossip-backstage-mirror&orientation=landscape",
    date: "2026-10-14",
    author: "编辑 · 周未",
    tags: ["沈知夏", "探班", "片场", "绯闻"],
    eventType: "绯闻",
    views: 762000,
    likes: 18900,
    content: [
      {
        type: "p",
        text: "有路透账号发布一段十几秒的视频，画面中沈知夏在片场休息区与一名男子并排而坐，两人边看手机边交谈。视频发布后迅速引发讨论，相关词条在两小时内进入热搜前十。",
      },
      {
        type: "p",
        text: "据剧组工作人员向媒体说明，该男子是沈知夏出道前的同学，近期因工作到访拍摄地附近，顺路探班，「全程有剧组人员在侧，不存在特殊关系」。",
      },
      { type: "h2", text: "路透时代的边界问题" },
      {
        type: "p",
        text: "这并非沈知夏第一次因片场路透被讨论。此前她在拍摄一场雨中戏时，被近距离围拍长达半小时，剧组不得不临时调整拍摄计划。业内人士指出，路透内容往往剥离语境，很容易让普通的社交场景被解读成情感新闻。",
      },
      {
        type: "quote",
        text: "「一段十几秒的视频，可以有几十种解读方式，但我们只能还原一种真实。」——剧组宣传人员的回应。",
      },
      {
        type: "p",
        text: "沈知夏目前正在拍摄都市剧《候鸟来信》，预计明年一季度杀青。对于网络上的讨论，其工作室暂未发布额外说明。",
      },
    ],
  },
  {
    id: "g3",
    title: "顾言公开否认与周漾绯闻：我们只是合作搭档，请把注意力放回作品",
    excerpt:
      "在新片发布会上，顾言首次正面回应持续半个月的绯闻，强调两人仅为合作关系，并希望媒体减少对私生活的追问。",
    category: "gossip",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20press%20conference%20microphones%20on%20a%20dark%20wooden%20table%20with%20shallow%20depth%20of%20field%2C%20warm%20spotlight%2C%20blurred%20press%20conference%20background%2C%20editorial%20photography&width=800&height=600&seq=gossip-press-mics&orientation=landscape",
    date: "2026-10-11",
    author: "编辑 · 林小满",
    tags: ["顾言", "周漾", "澄清", "发布会"],
    eventType: "澄清",
    views: 534000,
    likes: 15600,
    content: [
      {
        type: "p",
        text: "绯闻始于半个月前的一组同框照片。顾言与周漾被拍到在同一家餐厅用餐，随后有营销号放出所谓「情侣同款项链」的对比图，引发大量讨论。",
      },
      {
        type: "p",
        text: "在昨日的新片发布会上，顾言被记者问及此事，他没有回避：「我们确实认识很多年，是很好的合作搭档。那天是剧组聚餐，现场有十几个人。至于项链，是品牌方送的同一批礼物。」",
      },
      { type: "h2", text: "「希望讨论回到作品本身」" },
      {
        type: "p",
        text: "顾言随后补充，自己并不排斥被关注，但希望讨论能更多落在作品上。「一部戏拍了一年多，如果最后的讨论只剩绯闻，对团队不太公平。」",
      },
      {
        type: "quote",
        text: "「我不太会处理这些，只能把话说清楚。剩下的时间想留给角色。」——顾言",
      },
      {
        type: "p",
        text: "周漾方面暂未回应。其工作室此前在粉丝群里表示「不参与话题营销，请大家理性讨论」。",
      },
    ],
  },
  {
    id: "g4",
    title: "宋柯婚礼细节曝光 伴郎团阵容引发热议",
    excerpt:
      "婚礼选址在海边小城，仅邀请亲友约八十人，伴郎团由多年好友组成，现场布置以白色与麦穗为主。",
    category: "gossip",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20wedding%20still%20life%20with%20white%20bouquet%2C%20two%20gold%20rings%20on%20ivory%20silk%20fabric%2C%20soft%20morning%20light%2C%20minimal%20warm%20neutral%20tones%2C%20editorial%20photography&width=800&height=600&seq=gossip-wedding-silk&orientation=landscape",
    date: "2026-10-09",
    author: "编辑 · 周未",
    tags: ["宋柯", "婚礼", "伴郎团", "恋情"],
    eventType: "恋情",
    views: 498000,
    likes: 22100,
    content: [
      {
        type: "p",
        text: "宋柯的婚礼于上周六在南方一座海边小城举行。据参与筹备的工作人员透露，仪式规模控制在八十人左右，只邀请双方亲友与少数工作伙伴。",
      },
      {
        type: "p",
        text: "现场以白色花艺与麦穗装饰为主，没有设置传统的大屏互动环节。仪式在日落前半小时开始，持续约四十分钟。",
      },
      { type: "h2", text: "伴郎团成最大彩蛋" },
      {
        type: "p",
        text: "最受关注的是伴郎团阵容。四位伴郎均为宋柯入行前的好友，其中两位并非圈内人。有宾客透露，伴郎致辞环节一度让全场笑成一片。",
      },
      {
        type: "p",
        text: "婚礼结束后，宋柯在社交平台发布一张背影照，配文「谢谢大家，我们很好」。评论区短时间内涌入数万条祝福。",
      },
    ],
  },
  {
    id: "g5",
    title: "许安然被拍与音乐人共进晚餐 十指紧扣画面流出",
    excerpt:
      "两人被拍到在一家小馆用餐近两小时，离开时手牵手走向停车场，画面清晰度较高，讨论持续升温。",
    category: "gossip",
    cover:
      "https://readdy.ai/api/search-image?query=Intimate%20restaurant%20table%20at%20night%20with%20two%20coffee%20cups%2C%20candle%20light%20and%20warm%20bokeh%20background%2C%20no%20people%2C%20cinematic%20editorial%20photography%2C%20amber%20tones&width=800&height=600&seq=gossip-dinner-candle&orientation=landscape",
    date: "2026-10-06",
    author: "编辑 · 沈一白",
    tags: ["许安然", "音乐人", "恋情", "同框"],
    eventType: "恋情",
    views: 887000,
    likes: 31200,
    content: [
      {
        type: "p",
        text: "有媒体发布一组夜间照片，称许安然与一位音乐人在城区一家小馆用餐近两小时，离店时两人手牵手走向停车场。照片中两人均未佩戴口罩。",
      },
      {
        type: "p",
        text: "该音乐人此前参与过许安然两张专辑的编曲工作，两人在采访中多次提到彼此的创作默契。",
      },
      { type: "h2", text: "团队保持沉默" },
      {
        type: "p",
        text: "截至发稿，许安然方面未作任何回应。其经纪团队近半年对私人问题一律采取不回应策略，仅在作品发布期集中接受采访。",
      },
      {
        type: "quote",
        text: "「音乐上的事我可以说很久，其他的就先留给我自己吧。」——许安然在此前一次电台节目中的表述。",
      },
    ],
  },
  {
    id: "g6",
    title: "陆知遥回应分手传闻：感情状况一切正常，别替我安排剧情",
    excerpt:
      "因连续两个月未同框，陆知遥被传与伴侣分手。她在直播中直接回应，语气轻松但也略显无奈。",
    category: "gossip",
    cover:
      "https://readdy.ai/api/search-image?query=Smartphone%20lying%20on%20a%20white%20marble%20table%20with%20soft%20window%20light%20and%20a%20cup%20of%20tea%2C%20clean%20minimal%20still%20life%2C%20warm%20neutral%20tones&width=800&height=600&seq=gossip-phone-marble&orientation=landscape",
    date: "2026-10-03",
    author: "编辑 · 林小满",
    tags: ["陆知遥", "澄清", "分手传闻"],
    eventType: "澄清",
    views: 402000,
    likes: 12800,
    content: [
      {
        type: "p",
        text: "分手传闻的起点是一条被删除的合照。有网友发现陆知遥的社交账号中少了一张与伴侣的合影，随后各种猜测开始扩散。",
      },
      {
        type: "p",
        text: "在近日的一场直播中，陆知遥主动提到这件事：「那张照片是商务合作到期，按规定下架的。大家不要替我安排剧情，我们挺好的。」",
      },
      { type: "h2", text: "被放大的「未同框」" },
      {
        type: "p",
        text: "从公开行程看，两人近两个月确实没有同框记录，但陆知遥的伴侣长期在海外工作，这样的间隔在过往也并不罕见。",
      },
      {
        type: "p",
        text: "她最后补充，之后会更谨慎地处理社交账号内容，「不想每次删东西都变成一条新闻」。",
      },
    ],
  },
  {
    id: "g7",
    title: "江屿机场偶遇前女友 两人同框气氛微妙",
    excerpt:
      "两人在候机区相距不到三米，被拍到短暂点头致意。相关画面引发网友对旧情的集体回忆。",
    category: "gossip",
    cover:
      "https://readdy.ai/api/search-image?query=Airport%20terminal%20window%20at%20dusk%20with%20an%20airplane%20on%20the%20tarmac%2C%20cool%20blue%20hour%20light%20and%20warm%20terminal%20lamps%2C%20empty%20seats%2C%20cinematic%20wide%20shot&width=800&height=600&seq=gossip-airport-dusk&orientation=landscape",
    date: "2026-09-30",
    author: "编辑 · 周未",
    tags: ["江屿", "机场", "绯闻", "同框"],
    eventType: "绯闻",
    views: 356000,
    likes: 9800,
    content: [
      {
        type: "p",
        text: "有网友在机场候机区拍到江屿与前女友先后出现在同一区域，两人相距不到三米，短暂点头致意后各自离开。",
      },
      {
        type: "p",
        text: "据现场旅客描述，双方都没有停留交谈，随行人员也各自保持距离。整个过程不到二十秒。",
      },
      { type: "h2", text: "网友的「考古」热潮" },
      {
        type: "p",
        text: "画面流出后，两人多年前的合作片段被大量翻出，相关话题在短时间内聚集了极高讨论量。也有网友呼吁不要过度解读普通的公共场合相遇。",
      },
      {
        type: "p",
        text: "江屿目前正在为新专辑做准备，其团队未对机场画面作出回应。",
      },
    ],
  },
  {
    id: "b1",
    title: "剧组天价片酬传闻再起 知情人曝光合同细节",
    excerpt:
      "一份据称来自剧组内部的合同截图在网络流传，涉及主演片酬与分成条款。多方回应称文件真实性存疑。",
    category: "black",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20life%20of%20film%20production%20clapperboard%20and%20stacked%20contract%20documents%20on%20a%20dark%20wooden%20desk%2C%20warm%20rim%20light%2C%20deep%20navy%20shadows%2C%20no%20readable%20text%2C%20editorial%20photography&width=1600&height=900&seq=black-contract-desk-2610&orientation=landscape",
    date: "2026-10-15",
    author: "深度组 · 陈默",
    tags: ["片酬", "剧组", "合同", "行业观察"],
    region: "大陆",
    views: 1562000,
    likes: 54300,
    featured: true,
    content: [
      {
        type: "p",
        text: "上周开始，一份据称来自某古装剧组内部的合同截图在多个社交平台流传。截图显示，某主演的基础片酬与后期分成条款被分列在两页文件中，数字部分被打了码，但比例条款清晰可见。",
      },
      {
        type: "p",
        text: "文件流出后，剧组方面回应称「内容存在明显拼接痕迹，已交由法务处理」。但也有两位不愿具名的剧组工作人员向媒体表示，类似的条款结构在行业内并不罕见。",
      },
      { type: "h2", text: "片酬结构的三种常见形式" },
      {
        type: "p",
        text: "一位从业十余年的制片人向本网解释，目前剧集项目的演员合作大致分为三种：纯固定片酬、固定片酬加播出奖励、以及以工作室名义参与投资分成。第三种形式在账面上往往不以「片酬」出现，这也是各种传闻难以核实的原因。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20monitors%20and%20lighting%20rigs%20at%20night%2C%20empty%20chair%2C%20warm%20practical%20lights%20against%20deep%20blue%20darkness%2C%20cinematic%20production%20still&width=1000&height=620&seq=black-film-set-monitor&orientation=landscape",
        caption: "业内人士称，片酬结构往往与项目的投资方式绑定。",
      },
      {
        type: "quote",
        text: "「真正需要讨论的不是某个数字，而是资金流向是否透明、结算是否合规。」——某影视公司制片负责人",
      },
      { type: "h2", text: "平台限价与项目成本的两难" },
      {
        type: "p",
        text: "近三年，平台对头部项目的成本审核明显趋严。多位从业者提到，限价政策确实压低了账面片酬，但也让部分合作转向更复杂的结算方式。",
      },
      {
        type: "p",
        text: "截至目前，尚无监管部门就此事发布说明。本网提醒，网络流传的合同文件存在伪造可能，请以官方信息为准。",
      },
    ],
  },
  {
    id: "b2",
    title: "选秀艺人合约纠纷升级 公司回应称将追究法律责任",
    excerpt:
      "出道两年后提出解约，双方就违约金与作品版权归属各执一词。案件已进入调解阶段。",
    category: "black",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20legal%20documents%20with%20a%20fountain%20pen%20and%20reading%20glasses%20on%20a%20grey%20desk%2C%20soft%20window%20light%2C%20muted%20moody%20tones%2C%20editorial%20still%20life%2C%20no%20readable%20text&width=800&height=600&seq=black-legal-docs&orientation=landscape",
    date: "2026-10-12",
    author: "深度组 · 陈默",
    tags: ["合约纠纷", "选秀", "解约", "违约金"],
    region: "大陆",
    views: 921000,
    likes: 27400,
    content: [
      {
        type: "p",
        text: "一位通过选秀节目出道的艺人近日向经纪公司发出解约函，理由是「长期超负荷行程与收入分配不透明」。公司随后发布声明，称艺人单方面解约缺乏依据，将依法追究违约责任。",
      },
      {
        type: "p",
        text: "争议焦点集中在两份文件上：一是出道时签订的十年独家经纪合约，二是去年补充签署的收益分配协议。艺人方认为补充协议存在重大误解，公司方则强调协议由双方自愿签署并经律师见证。",
      },
      { type: "h2", text: "练习生合约的普遍困境" },
      {
        type: "p",
        text: "一位曾处理多起艺人纠纷的律师向本网表示，此类合约通常约定高额违约金，而违约金是否合理，需要结合实际投入与艺人收入综合判断。「很多年轻艺人在签约时并没有完整理解条款，这是纠纷高发的根本原因。」",
      },
      {
        type: "quote",
        text: "「合约不是卖身契，也不是随时可以撕掉的纸。它需要双方都认真对待。」——娱乐法律师受访表述",
      },
      {
        type: "p",
        text: "目前案件已进入调解阶段。艺人原定的两场商业活动已被临时取消，具体原因未公开。",
      },
    ],
  },
  {
    id: "b3",
    title: "港台男星税务问题持续发酵 三部待播剧或受影响",
    excerpt:
      "相关调查已持续数月，涉及境外收入的申报口径。制作方正在评估播出排期与补拍方案。",
    category: "black",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20empty%20corridor%20with%20tall%20arched%20windows%20and%20strong%20light%20beams%2C%20navy%20and%20warm%20shadow%20contrast%2C%20minimal%20architectural%20cinematic%20photography%2C%20no%20people&width=1600&height=900&seq=black-corridor-light-2610&orientation=landscape",
    date: "2026-10-08",
    author: "深度组 · 何叙",
    tags: ["税务", "待播剧", "港台", "行业观察"],
    region: "港台",
    views: 1188000,
    likes: 33900,
    featured: true,
    content: [
      {
        type: "p",
        text: "据多家媒体交叉报道，一位长期活跃于港台与内地市场的男演员正在配合税务方面的核查，涉及收入申报口径与跨境结算方式。其经纪公司回应称「正在积极配合，暂不便透露细节」。",
      },
      {
        type: "p",
        text: "受影响的可能是三部处于待播状态的剧集。其中两部已完成全部制作，一部仍在后期阶段。",
      },
      { type: "h2", text: "制作方的三种选择" },
      {
        type: "p",
        text: "一位平台内容采购负责人表示，遇到此类情况通常有三种处理方式：调整排期等待结论、通过技术手段处理相关镜头、或者直接更换演员补拍。「补拍的成本最高，但在某些情况下是唯一可行的方案。」",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=Empty%20television%20studio%20with%20camera%20on%20tripod%20and%20folded%20chairs%2C%20single%20cold%20spotlight%20in%20darkness%2C%20moody%20navy%20tones%2C%20cinematic%20wide%20angle&width=1000&height=620&seq=black-empty-studio-room&orientation=landscape",
        caption: "多部待播项目正在重新评估播出节奏。",
      },
      {
        type: "quote",
        text: "「观众看到的是一部剧，背后是上百人的档期和资金。」——某制片公司项目负责人",
      },
      {
        type: "p",
        text: "截至发稿，尚无官方通报。相关平台表示「一切以主管部门的信息为准」。",
      },
    ],
  },
  {
    id: "b4",
    title: "欧美歌手巡演临时取消 主办方与团队互相指责",
    excerpt:
      "开场前三小时宣布取消，数万观众滞留场馆外。双方就设备标准与付款进度各执一词。",
    category: "black",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20spotlights%20and%20truss%20structure%20before%20showtime%2C%20fog%20in%20the%20air%2C%20deep%20blue%20and%20amber%20lighting%2C%20no%20people%2C%20cinematic%20wide%20shot&width=800&height=600&seq=black-empty-stage&orientation=landscape",
    date: "2026-10-04",
    author: "深度组 · 何叙",
    tags: ["巡演", "取消", "欧美", "演出市场"],
    region: "欧美",
    views: 674000,
    likes: 19800,
    content: [
      {
        type: "p",
        text: "原定于周末举行的两场演出在开场前三小时宣布取消。主办方发布公告称，因「技术条件未达到艺人团队要求」，演出无法如期进行，将全额退票。",
      },
      {
        type: "p",
        text: "艺人团队随后通过社交媒体回应，称主办方未按合同完成舞台承重与音响系统的升级，且部分款项尚未结清。双方声明在数小时内形成对立叙事。",
      },
      { type: "h2", text: "被忽视的观众成本" },
      {
        type: "p",
        text: "受影响观众超过三万人，其中不少人从外地赶来。除了票款，交通与住宿损失如何处理，公告中并未提及。当地消保机构已介入协调。",
      },
      {
        type: "quote",
        text: "「演出取消可以理解，但信息应该更早、更清楚。」——一位在场观众的表述",
      },
      {
        type: "p",
        text: "类似纠纷在近两年的演出市场并不少见。行业快速扩张之后，场馆条件、审批流程与票务机制的衔接问题正在集中暴露。",
      },
    ],
  },
  {
    id: "b5",
    title: "综艺剪辑争议背后：一档节目如何制造对立情绪",
    excerpt:
      "一段被剪掉的对话让嘉宾陷入舆论风暴。多位从业者讲述了「冲突感」如何被写进剪辑脚本。",
    category: "black",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20video%20editing%20studio%20with%20multiple%20monitors%20showing%20colorful%20timelines%2C%20keyboard%20and%20headphones%2C%20cool%20ambient%20glow%2C%20cinematic%20production%20atmosphere%2C%20no%20readable%20text&width=800&height=600&seq=black-editing-room&orientation=landscape",
    date: "2026-09-27",
    author: "深度组 · 陈默",
    tags: ["综艺", "剪辑", "争议", "舆论"],
    region: "大陆",
    views: 738000,
    likes: 24100,
    content: [
      {
        type: "p",
        text: "一档热门综艺在最新一期播出后陷入争议。节目中一段看似激烈的争执，被随后流出的完整素材证明前后还有近两分钟的解释性对话。",
      },
      {
        type: "p",
        text: "节目组回应称，剪辑需要服务于叙事节奏，「不存在恶意引导」。但多位综艺后期从业者向本网表示，制造情绪高点确实是当下的通行做法。",
      },
      { type: "h2", text: "「冲突感」的工业化生产" },
      {
        type: "p",
        text: "一位不愿具名的后期导演描述，一集九十分钟的节目，素材量往往超过三百小时。选段、配乐、字幕节奏都会影响观众的判断，「同样一句普通话，加一个反问号、配一段弦乐，感觉完全不同」。",
      },
      {
        type: "quote",
        text: "「观众以为自己在看真实，其实在看被选择过的真实。」——某综艺后期导演",
      },
      {
        type: "p",
        text: "事件发酵后，节目在平台上线了补充片段。但对于被卷入讨论的嘉宾而言，舆论的影响往往已经发生。",
      },
    ],
  },
  {
    id: "b6",
    title: "日韩偶像私生活照外流 事务所紧急发声",
    excerpt:
      "多张疑似私人聚会照片在海外论坛流传，事务所称将采取法律措施，并否认部分照片的真实性。",
    category: "black",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20professional%20camera%20lens%20with%20flash%20reflection%20in%20the%20dark%2C%20deep%20amber%20and%20navy%20tones%2C%20dramatic%20lighting%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=black-camera-lens&orientation=landscape",
    date: "2026-09-22",
    author: "深度组 · 何叙",
    tags: ["偶像", "照片外流", "日韩", "隐私"],
    region: "日韩",
    views: 812000,
    likes: 21600,
    content: [
      {
        type: "p",
        text: "上周起，多张疑似某偶像团体成员私人聚会的照片在海外论坛流传，其中部分照片包含明显的室内场景与友人合影。",
      },
      {
        type: "p",
        text: "事务所随后发布声明，确认已委托律师处理，并指出「部分图像经过合成，与事实不符」。声明同时呼吁粉丝不要二次传播。",
      },
      { type: "h2", text: "隐私与公众身份的拉锯" },
      {
        type: "p",
        text: "在偶像产业中，私生活往往被视为「人设」的一部分。一位熟悉日韩经纪体系的从业者表示，事务所的应对重点通常不是事实本身，而是舆论对商业价值的影响。",
      },
      {
        type: "p",
        text: "目前，相关论坛的部分帖子已被删除。是否有进一步法律行动，事务所表示「不便提前说明」。",
      },
    ],
  },
  {
    id: "b7",
    title: "代言翻车背后：品牌与艺人的责任边界在哪",
    excerpt:
      "一款代言产品因成分标注问题被下架，代言人被卷入舆论。法律责任与道德期待之间，界线并不清晰。",
    category: "black",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20cosmetic%20product%20bottles%20on%20a%20clean%20beige%20surface%20with%20soft%20directional%20light%20and%20subtle%20shadows%2C%20premium%20skincare%20still%20life%2C%20warm%20neutral%20palette%2C%20no%20text&width=800&height=600&seq=black-beauty-products&orientation=landscape",
    date: "2026-09-18",
    author: "深度组 · 陈默",
    tags: ["代言", "品牌", "责任", "消费维权"],
    region: "大陆",
    views: 589000,
    likes: 17400,
    content: [
      {
        type: "p",
        text: "某护肤品牌旗下一款产品因成分标注与实际检测结果不符被要求下架。由于代言人近两年频繁出现在该品牌的广告中，舆论迅速转向艺人本人。",
      },
      {
        type: "p",
        text: "代言人工作室发布声明，称合作前已审核相关资质文件，事件发生后已第一时间要求品牌方说明情况，并暂停后续合作。",
      },
      { type: "h2", text: "代言审核到底审什么" },
      {
        type: "p",
        text: "一位广告合规顾问向本网介绍，艺人方通常审核的是品牌资质、产品备案与广告用语，很难对每批次产品的实际成分进行检测。「这决定了艺人承担的是合同责任，而非产品责任。」",
      },
      {
        type: "quote",
        text: "「公众期待艺人像专家一样把关，但制度上他们并不是。」——广告合规顾问",
      },
      {
        type: "p",
        text: "目前品牌方已启动退货流程。监管部门表示调查仍在进行中。",
      },
    ],
  },
  {
    id: "n1",
    title: "年度华语电影市场观察：类型片正在接管票房",
    excerpt:
      "从悬疑到科幻，类型明确的中等成本影片成为市场主力。观众的选择正在重塑投资逻辑。",
    category: "news",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20vintage%20cinema%20auditorium%20with%20rows%20of%20deep%20red%20velvet%20seats%20and%20glowing%20screen%20light%2C%20empty%20theater%2C%20cinematic%20wide%20shot%2C%20warm%20amber%20and%20dark%20navy%20tones&width=1600&height=900&seq=news-cinema-hall-2610&orientation=landscape",
    date: "2026-10-13",
    author: "产业组 · 苏黎",
    tags: ["电影", "票房", "类型片", "行业观察"],
    newsType: "电影",
    views: 342000,
    likes: 8600,
    featured: true,
    content: [
      {
        type: "p",
        text: "过去十二个月，华语电影市场出现了一个明显变化：票房前十的作品中，有七部属于类型特征极强的中等成本影片，而非传统意义上的大制作。",
      },
      {
        type: "p",
        text: "这一变化并非偶然。多位发行方人士提到，观众对「大而空」的项目正在快速失去耐心，明确的类型承诺反而成为购票决策的关键。",
      },
      { type: "h2", text: "中等成本的机会窗口" },
      {
        type: "p",
        text: "一部成本约六千万的悬疑片在今年暑期档拿下超过十二亿票房，成为年度最具讨论度的案例。其制片人认为，成功的关键在于「把所有的钱花在观众能看见的地方」。",
      },
      {
        type: "quote",
        text: "「观众不再为阵容买单，他们为确定性买单。」——某发行公司负责人",
      },
      {
        type: "p",
        text: "不过，类型片的集中出现也带来同质化风险。接下来的一年，市场将检验这股热潮能否沉淀为稳定的工业能力。",
      },
    ],
  },
  {
    id: "n2",
    title: "悬疑剧集扎堆上线 观众审美疲劳还是内容升级",
    excerpt:
      "本季度上线的悬疑剧超过十部，口碑分化明显。创作者开始尝试更难的结构与更慢的节奏。",
    category: "news",
    cover:
      "https://readdy.ai/api/search-image?query=Television%20series%20set%20with%20monitors%2C%20lighting%20rig%20and%20director%20chair%20in%20a%20dim%20studio%2C%20warm%20practical%20lights%2C%20cinematic%20behind%20the%20scenes%20atmosphere%2C%20no%20people&width=800&height=600&seq=news-tv-set&orientation=landscape",
    date: "2026-10-10",
    author: "产业组 · 苏黎",
    tags: ["电视剧", "悬疑", "口碑", "行业观察"],
    newsType: "电视剧",
    views: 268000,
    likes: 6400,
    content: [
      {
        type: "p",
        text: "本季度上线的悬疑题材剧集超过十部，创下近年新高。但从评分分布看，口碑两极分化严重，最高与最低相差超过三分。",
      },
      {
        type: "p",
        text: "观众反馈中最常见的问题是「前两集信息量太大、后面开始注水」。也有作品因坚持慢节奏与复杂结构获得好评，但收视表现并不突出。",
      },
      { type: "h2", text: "创作者的两难" },
      {
        type: "p",
        text: "一位悬疑剧编剧表示，平台对前几集的留存率要求越来越高，导致大量信息被压缩到开篇，「观众还没进入情境，就被塞了一堆线索」。",
      },
      {
        type: "p",
        text: "接下来的档期仍有数部悬疑项目待播。市场能否消化如此密集的供给，还需要时间验证。",
      },
    ],
  },
  {
    id: "n3",
    title: "慢综艺回归 生活类节目为何重新受欢迎",
    excerpt:
      "没有任务、没有淘汰，几档生活类节目悄悄走高。观众需要的或许不是刺激，而是陪伴。",
    category: "news",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20countryside%20house%20with%20wooden%20porch%20and%20garden%20in%20soft%20morning%20light%2C%20linen%20curtains%20and%20potted%20plants%2C%20warm%20natural%20tones%2C%20editorial%20travel%20photography%2C%20no%20people&width=800&height=600&seq=news-countryside-house&orientation=landscape",
    date: "2026-10-02",
    author: "产业组 · 罗一",
    tags: ["综艺", "慢综艺", "生活", "观众"],
    newsType: "综艺",
    views: 197000,
    likes: 5900,
    content: [
      {
        type: "p",
        text: "在强情节综艺持续内卷的同时，几档节奏缓慢的生活类节目悄然走高。它们的共同点是：没有淘汰机制，没有任务冲突，镜头大量停留在做饭、聊天与发呆上。",
      },
      {
        type: "p",
        text: "一位节目总导演认为，这类内容的价值在于「提供一个不需要紧张的时段」。「观众不是来看胜负的，是来待一会儿的。」",
      },
      { type: "h2", text: "陪伴感成为稀缺资源" },
      {
        type: "p",
        text: "数据也支持这一判断。几档慢综艺的完播率明显高于同类，但社交话题量偏低——它们不制造热搜，却留下了稳定的观看时长。",
      },
      {
        type: "p",
        text: "业内人士预计，明年的综艺市场会出现更多「低冲突、高质感」的项目，但能否复制成功仍是未知数。",
      },
    ],
  },
  {
    id: "n4",
    title: "音乐节数量创新高 演出市场进入精细化竞争",
    excerpt:
      "全年音乐节场次再创新高，但观众对阵容与体验的要求同步提升，粗放式办节正在被淘汰。",
    category: "news",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20crowd%20silhouette%20at%20sunset%20with%20stage%20lights%20and%20warm%20orange%20sky%2C%20wide%20atmospheric%20shot%2C%20cinematic%20concert%20photography%2C%20no%20recognizable%20faces&width=800&height=600&seq=news-festival-sunset&orientation=landscape",
    date: "2026-09-25",
    author: "产业组 · 罗一",
    tags: ["音乐", "音乐节", "演出市场", "消费"],
    newsType: "音乐",
    views: 164000,
    likes: 4700,
    content: [
      {
        type: "p",
        text: "据不完全统计，今年全国举办的音乐节场次较去年增长近三成，创下历史新高。但与此同时，多个项目因售票不及预期临时取消。",
      },
      {
        type: "p",
        text: "观众的选择正在变得挑剔。阵容同质化、交通接驳不便、现场餐饮价格过高，都会在社交平台迅速放大，直接影响下一场的销售。",
      },
      { type: "h2", text: "从拼阵容到拼体验" },
      {
        type: "p",
        text: "一些主办方开始调整策略：减少场次、提高单场投入、增加休息区与免费饮水点，并把本地文化元素纳入整体设计。",
      },
      {
        type: "p",
        text: "「观众愿意为体验付费，但不愿意为凑数的阵容付费。」一位主办方负责人这样总结这一年的变化。",
      },
    ],
  },
];

export const featuredArticles = articles.filter((item) => item.featured);

export const hotArticles = [...articles].sort((a, b) => b.views - a.views).slice(0, 6);

export const gossipEventTypes = ["全部", "恋情", "绯闻", "澄清"];
export const blackRegions = ["全部", "大陆", "港台", "欧美", "日韩"];
export const newsTypes = ["全部", "电影", "电视剧", "综艺", "音乐"];
export const timeRanges = [
  { label: "全部时间", value: "all" },
  { label: "近 7 天", value: "7" },
  { label: "近 30 天", value: "30" },
  { label: "近 90 天", value: "90" },
];

export const starNames = [
  "林澈",
  "苏念",
  "沈知夏",
  "顾言",
  "周漾",
  "宋柯",
  "许安然",
  "陆知遥",
  "江屿",
];